import { BrowserProvider, getAddress, type Eip1193Provider } from 'ethers'
import { deleteRequestTypedData } from './safe.js'
import { deleteMultisigTx } from './safeTxService.js'
import type { Hex } from '../types.js'

/**
 * Sign + DELETE pipeline for "remove from queue" — pulls the wallet/signing
 * orchestration out of TxCard so it's testable without React.
 */

export interface DeleteArgs {
  safeTxHash: Hex
  walletProvider: Eip1193Provider
  signerAddress: string
  moduleSafe: string
  chainId: number
  onProgress?: (stage: DeleteStage) => void
}

export type DeleteStage = 'signing' | 'deleting'

export async function deleteModuleTx(args: DeleteArgs): Promise<void> {
  const {
    safeTxHash,
    walletProvider,
    signerAddress,
    moduleSafe,
    chainId,
    onProgress,
  } = args

  onProgress?.('signing')
  const typed = deleteRequestTypedData(chainId, moduleSafe, safeTxHash)
  const browser = new BrowserProvider(walletProvider, chainId)
  const signer = await browser.getSigner(getAddress(signerAddress))
  const signature = await signer.signTypedData(
    typed.domain,
    typed.types,
    typed.message,
  )

  onProgress?.('deleting')
  await deleteMultisigTx(safeTxHash, signature)
}
